export default "__VITE_ASSET__DItXmQ1p__"